export class CursorInDocument {
    x = 0;
    y = 0;

    constructor() {
        this.initMouseMoveEvent();
    }

    initMouseMoveEvent() {
        document.onmousemove = (e) => {
            this.x = e.pageX;
            this.y = e.pageY;
        };
    }
}
